// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bX6y","content":"styles_content__19I4z"};